// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"style_spinnerWrapper__38-HO"};